<template>
  <div id="app">
    <help-hub-header
      :env="environment"
      :title="'Employee Hub'"
      @onHHComponentSuccess="onHHComponentSuccess"
      @onHHComponentError="onHHComponentError"
      @onFeedbackSuccess="onFeedbackSuccess"
    />
    <nav-banner v-if="authToken"
      @onSearchTermChanged="updateSearchTerm"
      @onSearchTermCleared="clearSearchTerm"
      ref="navBanner"
    />
    <modals-container />
    <loading-spinner v-if="!authToken"></loading-spinner>

      <div v-if="authToken && !isLoading">
        <div class="bg-white">
          <div class="main-container" :class="searchTerm ? 'container-fluid':'container'">

        <!-- shortcut buttons -->
        <div v-if="showAPAdminViewBtn && !searchTerm" class="helphub-app-container pt-2 container">
          <div class="row align-breadcrumb-btn justify-content-lg-end justify-content-md-start">
            <button class="btn breadcrumb-button offset-md-0 offset-1 mb-2"
                    v-if="showSubmitPaymentBtn && !this.viewingAPUserDataFor" @click="navigateToSubmitPayment">{{FORM_LABELS.SUBMIT_AN_INVOICE}}</button>
            <toggle-admin-view v-if="showAPAdminViewBtn"></toggle-admin-view>
          </div>
        </div>

        <div v-else-if="!searchTerm" class="helphub-app-container pt-2 container">
          <div class="row justify-content-lg-end justify-content-md-start pr-lg-5">
            <button class="btn breadcrumb-button"
                    v-if="showSubmitPaymentBtn" @click="navigateToSubmitPayment">{{FORM_LABELS.SUBMIT_AN_INVOICE}}</button>
            <button class="btn breadcrumb-button"
                    v-else-if="showBtnOnBreadcrumb" @click="launchOneIntakeForm">Engage a supplier</button>
          </div>
        </div>
        

        <!-- search results -->
        <div v-if="searchTerm" class="container">
          <div class="print-width-100 col-12 col-xl-5 col-lg-6 col-md-9 col-12">
            <search-results :search-term="searchTerm" @clearSearchTerm="clearSearchTerm"></search-results>
          </div>
        </div>
        <div v-else :class="[currentRouteHasForms ? 'print-width-100 col-12 px-md-5 px-0 pb-5' : '']">
          <router-view :key="$route.fullPath"></router-view>
        </div>

      </div>
        </div>
     </div>
    <help-hub-footer :env="environment" v-if="!isLoading" />
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import LoadingSpinner from "./components/LoadingSpinner";
import CONSTANTS from "@/store/constants";
import { mapActions, mapGetters, mapMutations } from "vuex";
import SearchResults from "./components/SearchResults";
import FORM_LABELS from "@/store/FormLabels";
import ToggleAdminView from "./components/InvoiceAndPurchaseOrders/ToggleAdminView";
import NavBanner from "@/components/homepage/NavBanner";
// END OF IMPORTS

export default {
  name: "app",
  components: { ToggleAdminView, SearchResults, LoadingSpinner, NavBanner },
  data() {
    return {
      FORM_LABELS: FORM_LABELS,
      environment: CONSTANTS.ENV,
      authToken: null,
      isLoading: true,
      searchTerm: null,
      inputSearchText: null,
      AllAPUsers: [],
    };
  },
  watch: {
    async "currentUser.userName"() {
      //Only call the API when there is no APUsers already, i.e: - true on initial load, else we trigger only setting the ApUser
      if (this.AllAPUsers.length === 0) {
        await this.getAllAPUserListData();
      } else {
        this.isAPUserViewToggle();
      }
    },
  },
  computed: {
    ...mapGetters([
      "currentAppData",
      "currentAlias",
      "allCategories",
      "currentUser",
      "showSearchSpinner",
      "isAPAdmin",
      "viewingAPUserDataFor",
      "adminAPUserList",
    ]),
    currentRouteHasForms() {
      return (
        this.$route.path.includes("/one-intake-form") ||
        this.$route.path.includes("/payment-types") ||
        this.$route.name.includes(CONSTANTS.NON_PO_PAYMENT_FORM) ||
        this.$route.name.includes(CONSTANTS.PO_BASED_PAYMENT_FORM) ||
        this.$route.name.includes(CONSTANTS.ADV_PO_BASED_PAYMENT_FORM) ||
        this.$route.name.includes(CONSTANTS.ONE_TIME_SUPPLIER_PAYMENT) ||
        this.$route.name.includes(CONSTANTS.INVOICE_SUBMISSION_FORM) ||
        this.$route.name.includes(CONSTANTS.EXCEPTION_SUBMISSION_FORM)
      );
    },
    showBtnOnBreadcrumb() {
      /* Disable breadcrumb btn on DraftRequests, OnBoardRequests and HomePage */
      return (
        this.$route.path !== "/" + CONSTANTS.GUIDES_ALIAS &&
        !this.currentRouteHasForms
      );
    },
    showSubmitPaymentBtn() {
      return this.$route.meta.showSubmitPaymentBtn;
    },
    showAPAdminViewBtn() {
      return this.isAPAdmin && this.$route.meta.showAPAdminViewBtn;
    },
  },
  methods: {
    ...mapMutations([
      "setAuthResponse",
      "setIsModalOpenFromBreadcrumbBtn",
      "setisAPAdmin",
      "setErrorMessage",
      "setCognitoAccessToken",
    ]),
    ...mapActions(["fetchAllAdminUsers"]),
    navigateToSubmitPayment() {
      this.setIsModalOpenFromBreadcrumbBtn(true);
      this.$router.push("/payment-types");
    },
    navigateToSubmitInvoice() {
      this.$router.push("/invoice-submission");
    },
    updateSearchTerm(payload) {
      this.searchTerm = payload;
    },
    clearSearchTerm() {
      this.$refs.navBanner.searchTerm = null;
    },
    onHHComponentSuccess(response) {
      response = response.detail[0];

      let cognitoAccessToken = response.idToken;
      this.setCognitoAccessToken(cognitoAccessToken);

      this.isLoading = false;

      axios.defaults.headers["Authorization"] =
        "Bearer " + response.accessToken;
      axios.defaults.baseURL = CONSTANTS.EMPLOYEE_HUB_GUIDES_API_BASE_URL;
      this.authToken = response.accessToken;
      this.setAuthResponse(response);
      var mixpanelInstance = response.mixpanelInstance;
      // Only initialize mixpanel once
      Vue.mixin({
        created: function () {
          this.CONSTANTS = CONSTANTS;
        },
      });
      if (mixpanelInstance && !Vue.prototype.$hhMixpanel) {
        Vue.prototype.$hhMixpanel = mixpanelInstance;
        mixpanelInstance.addRouterAutoTracking(this.$router);
      }
    },

    launchOneIntakeForm() {
      this.clearSearchTerm();
      this.$router.push({ name: "OneIntakeForm" });
    },

    onHHComponentError() {
      this.isLoading = false;
    },
    async getAllAPUserListData() {
      this.fetchAllAdminUsers(true).finally(() => {
        this.AllAPUsers = [...this.adminAPUserList];
        this.isAPUserViewToggle();
      });
    },

    isAPUserViewToggle() {
      this.setisAPAdmin(
        this.AllAPUsers.some(
          (APUser) =>
            APUser.windowsId.trim().toUpperCase() ===
            this.currentUser.userName.trim().toUpperCase()
        )
      );
    },
    onFeedbackSuccess(response) {
      Vue.prototype.$ehFeedbackInstance = response.detail[0].feedbackInstance
    },
  },
};
</script>
<style scoped>
.title-wrapper >>> .section-non-self-service {
  padding-left: 8% !important;
}

.title-wrapper >>> .search-container {
  padding-left: 9.2% !important;
}

.search-container .input-group-text {
  background-color: transparent;
  border-right: none;
  border-top-left-radius: 25px;
  border-bottom-left-radius: 25px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  color: #fff;
  padding-right: 5px;
  cursor: pointer;
  opacity: 0.8;
  border-color: #fff;
}

.search-container {
  background: #1758a7;
  margin-top: -2px;
}
.input-group-text {
  display: flex;
  -ms-flex-align: center;
  -webkit-box-align: center;
  align-items: center;
  padding: 0.375rem 0.77rem;
  margin-bottom: 0;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  background-color: #e9ecef;
  border: 1px solid #ced4da;
}
.search-container input {
  border-radius: 25px;
  border-left: none;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  font-size: 14px;
  opacity: 0.8;
  padding-left: 8px;
  background-color: transparent;
  border-color: #fff;
}
.search-input-container {
  margin-right: 15px;
  height: 40px;
}
.search-input-container .form-control {
  height: 100%;
  color: #fff !important;
}
.input-container {
  width: 100%;
}

.input-container input::-ms-clear {
  display: none;
  width: 0;
  height: 0;
}
.input-container input::-ms-reveal {
  display: none;
  width: 0;
  height: 0;
}

.close-btn {
  position: absolute;
  right: 35px;
  top: -1px;
  height: 100%;
  outline: none;
  color: #fff;
}

.close-btn svg {
  width: 0.65em;
  height: 0.8em;
  color: #fff;
}
.breadcrumb-desc {
  color: #fff;
  font-size: 16px;
  /* padding-left: 2.7em !important; */
  margin-top: -35px;
}

::-webkit-input-placeholder {
  /* Edge */
  color: #fff !important;
}

:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #fff !important;
}

::placeholder {
  color: #fff !important;
}

@media screen and (min-width: 2200px) {
  help-hub-breadcrumb >>> .breadcrumb-title {
    padding-left: 0.5rem;
  }
}

@media screen and (min-width: 992px) and (max-width: 1199px) {
  .align-breadcrumb-btn {
    padding-left: 1%;
  }
}

@media screen and (min-width: 768px) and (max-width: 992px) {
  .align-breadcrumb-btn {
    padding-left: 6%;
  }
}

.main-container {
  min-height: 900px !important;
}
</style>

<style>
.bookmark-icon-green {
  color: #0a86ff !important;
}

.search-loading-spinner {
  width: 25px;
  height: 25px;
}

body {
  background: #fff !important;
  overflow-x:hidden !important;
}

.breadcrumb-button {
  background-color: #FFFFFF !important;
  border: 1px solid #000 !important;
  z-index: 10;
  color: #000 !important;
  font-weight: bold !important;
  max-width: 18rem !important;
  white-space: nowrap;
}
</style>